<template>
    <el-input
      :value="currentValue"
      @blur="handleBlur"
      @input="handleInput"
      :size="size"
      :disabled="disabled"
      :style="{width: width}"
      :placeholder="placeholder"
      ref="input">
    </el-input>
</template>
<script>
    /**
     * 数字输入组件，（此版，先满足金额的输入）
     * @author zjs
     * @time 2017-09-28
     */
    export default {
        name: 'LyInputNumber',
        props: {
            value: {
                default: ''
            },
            disabled: {
                default: false
            },
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: 0
            },
            width: String, // 输入框面板的宽度
            size: String,
            placeholder: {
                default: ''
            }
        },
        data () {
            return {
                currentValue: ''
            }
        },
        watch: {
            value: {
                immediate: true,
                handler (value) {
                    // console.log('value handle',value)
                    if (this.currentValue === value) return
                    let newVal = Number(value)
                    if (isNaN(newVal)) return
                    // 小数点的位置
                    let index = String(newVal).indexOf('.')
                    // 数字的长度
                    let len = String(newVal).length
                    if (index > 0 && (len - index) > 3) {
                        newVal = newVal.toFixed(2)
                    }
                    // console.log("newVAl-:", newVal)
                    // console.log("min:", this.min)
                    if (newVal >= this.max) newVal = this.max
                    if (newVal <= this.min) newVal = this.min
                    this.currentValue = newVal
                    // console.log("newVAl:", newVal)
                    this.$emit('input', newVal)
                }
            }
         },
        methods: {
            handleBlur () {
                console.log('blur')
                this.setInputValue(this.currentValue)
            },
            handleInput (value) {
                if (isNaN(value)) {
                    // 负号处理
                    if (String(value).trim() === '-') this.currentValue = '-'
                    this.$refs.input.setNativeInputValue(this.currentValue)
                } else if (String(value).trim() === '') {
                    // 删空的处理
                    this.currentValue = ''
                    this.$refs.input.setNativeInputValue(this.currentValue)
                } else {
                    let newVal = Number(value)
                    // let oldVal = this.currentValue
                    // 数字的长度
                    let len = String(value).length
                    // if (index > 0) {
                    //     if (len - index > 3) {
                    //         // 只能输入两位小数
                    //         newVal = Number(value.slice(0,index) + '.' + value.slice(index + 1,index + 3)).toFixed(2)
                    //     }
                    //     // 输入小数点的处理
                    //     if (len - 1 === index) {
                    //         this.currentValue = value
                    //         return
                    //     }
                    // }
                    // 最大可输入数
                    if (newVal >= this.max) newVal = this.max
                    // 最小可输入数
                    if (newVal <= this.min) newVal = this.min
                    // if (oldVal === newVal) {
                    //     this.$refs.input.setNativeInputValue(this.currentValue)
                    //     return
                    // }
                    // -0 这种情况
                    if (newVal === 0 && len > 1) {
                        newVal = value
                    }
                    // 小数点的位置
                    let index = String(value).indexOf('.')
                    if (index > 0) {
                        let numArray = String(value).split('.')
                        if (len - 1 === index) {
                            newVal = value
                        } else if (numArray[1].length > 2) {
                            numArray[1] = numArray[1].slice(0,2)
                            newVal = numArray.join('.')
                        }
                    }
                    this.currentValue = newVal
                    this.$emit('input', newVal)
                }
            },
            debounceHandleInput (value) {
                if (value === '-') {
                    this.currentValue = '-'
                }
                const newVal = value // Number(value)
                if (!isNaN(newVal)) {
                    // let val = newVal
                    // if (String(val).indexOf('.') > 0) {
                    //     val = val.toFixed(2)
                    // }
                    this.setCurrentValue(newVal)
                } else {
                    this.setInputValue(this.currentValue)
                    // this.$refs.input.setCurrentValue(value)
                    // this.currentValue = value
                }
            },
            /**
             * 此段代码来自element-ui input-number.vue
             */
            setCurrentValue (newVal) {
                // if (String(newVal).indexOf('.') > 0) {
                //     newVal = newVal.toFixed(2)
                // }
                newVal = Number(newVal)
                const oldVal = this.currentValue
                if (newVal >= this.max) newVal = this.max
                if (newVal <= this.min) newVal = this.min
                if (oldVal === newVal) {
                  this.setInputValue(this.currentValue)
                  return
                }
                this.$emit('input', newVal)
                this.currentValue = newVal
            },
            setInputValue (value) {
                if (!isNaN(value)) {
                    value = Number(value)
                    this.$emit('input', value)
                }
                this.currentValue = value
                this.$refs.input.setNativeInputValue(value)
            }
        }
    }
</script>